import {NewsArticleCategory, ValueOfOption} from '../types';

export default function getNewsArticleCategoryLabel(
  categoryValue: ValueOfOption<typeof NewsArticleCategory>,
) {
  return Object.values(NewsArticleCategory).find(
    ({value}) => value === categoryValue,
  )?.label;
}
